import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { DocumentTemplate } from '../DocumentTemplate'
import type { BillOfMaterials } from '@/state'

export const BillOfMaterialsTable = ({
  id,
  createdAt,
  versionName,
  isLatestDocumentVersion,
  fullScreen,
  order,
  rows,
}: {
  id?: string
  versionName: string
  createdAt: string
  isLatestDocumentVersion?: boolean
  fullScreen?: boolean
  order?: number
  rows: BillOfMaterials
}) => {
  return (
    <DocumentTemplate
      id={id || `parts-bom`}
      title="Bill of Materials"
      createdAt={createdAt}
      versionName={versionName}
      isLatestDocumentVersion={isLatestDocumentVersion}
      order={order || 3}
      fullScreen={fullScreen}
    >
      <div id="bom">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Part name</TableHead>
              <TableHead>Quantity</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((item, i) => (
              <TableRow key={i}>
                <TableCell className="py-1 px-2.5">{item.partName}</TableCell>
                <TableCell className="py-1 px-2.5">
                  {item.quantity ? item.quantity : ''}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </DocumentTemplate>
  )
}
